"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COLLAPSE_ROOT_CLASS_NAME = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _Collapse2 = _interopRequireDefault(require("./Collapse.style"));
var _excluded = ["children", "classPrefix", "header", "footer", "dataTestId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var COLLAPSE_ROOT_CLASS_NAME = exports.COLLAPSE_ROOT_CLASS_NAME = 'Collapse';
var Collapse = /*#__PURE__*/function (_React$Component) {
  function Collapse(props) {
    var _this;
    _classCallCheck(this, Collapse);
    _this = _callSuper(this, Collapse, [props]);
    _defineProperty(_this, "getOpenItems", function () {
      return _this.props.openItems || _this.props.defaultOpen && _this.props.items && _this.props.items.map(function (_, index) {
        return index;
      }) || [];
    });
    _defineProperty(_this, "collapseAll", function () {
      if (_this.state.openItems.length > 0) {
        _this.setState({
          openItems: []
        });
      }
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_this, "handleClickOutside", function () {
      var externalCollapse = _this.props.externalCollapse;
      if (externalCollapse) _this.collapseAll();
    });
    _defineProperty(_this, "toggle", function (index) {
      var openItems = _this.state.openItems;
      var multi = _this.props.multi;
      var closing = openItems.includes(index);
      if (!closing && !multi) {
        return _this.setState({
          openItems: [index]
        });
      }
      return _this.setState({
        openItems: closing ? openItems.filter(function (i) {
          return i !== index;
        }) : [].concat(_toConsumableArray(openItems), [index])
      });
    });
    _this.state = {
      openItems: _this.getOpenItems()
    };
    return _this;
  }
  _inherits(Collapse, _React$Component);
  return _createClass(Collapse, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        classPrefix = _this$props.classPrefix,
        header = _this$props.header,
        footer = _this$props.footer,
        dataTestId = _this$props.dataTestId,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var openItems = this.state.openItems;
      return /*#__PURE__*/_react["default"].createElement(_Collapse2["default"], _extends({
        className: classPrefix
      }, otherProps, {
        "data-testid": dataTestId
      }), header && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "-header")
      }, header), children && children({
        toggle: this.toggle,
        openItems: openItems,
        classPrefix: classPrefix,
        collapseAll: this.collapseAll
      }), footer && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "-footer")
      }, footer));
    }
  }]);
}(_react["default"].Component);
Collapse.propTypes = {
  openItems: _propTypes["default"].arrayOf(_propTypes["default"].number),
  children: _propTypes["default"].func.isRequired,
  header: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  /* If the component should collapse when clicking outside it */
  externalCollapse: _propTypes["default"].bool,
  classPrefix: _propTypes["default"].string,
  multi: _propTypes["default"].bool,
  defaultOpen: _propTypes["default"].bool,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  dataTestId: _propTypes["default"].string
};
Collapse.defaultProps = {
  openItems: null,
  header: null,
  footer: null,
  externalCollapse: false,
  classPrefix: COLLAPSE_ROOT_CLASS_NAME,
  multi: true,
  defaultOpen: true,
  items: null,
  dataTestId: 'collapse-wrapper'
};
var _default = exports["default"] = (0, _reactClickOutside["default"])(Collapse);